import { useQuery } from '@tanstack/react-query';

import { Account, GUID } from '@ndvr/portfolio-api';

import { Configuration, TaxMetricsApi } from '@/cip/_openapi/portfolio-optimizer';
import { defaultApiConfig } from '@/cip/api/defaultApiConfig';

const taxMetricsApi = new TaxMetricsApi(new Configuration(defaultApiConfig));

export const ytdTaxMetricsQueryKey = (accountGUID?: GUID<Account>) => ['taxMetrics', 'ytd', accountGUID];
const accountsYtdTaxMetricsQueryKey = (accountGUIDs: GUID<Account>[]) => [
    'taxMetrics',
    'ytd',
    [...accountGUIDs].sort(),
];

export const useAccountsYtdTaxMetrics = (accountGUIDs: GUID<Account>[], options?: { throwOnError?: boolean }) =>
    useQuery({
        ...options,
        queryKey: accountsYtdTaxMetricsQueryKey(accountGUIDs),
        queryFn: () =>
            taxMetricsApi.getYtdTaxMetrics({
                ytdTaxMetricsRequest: { accountGuids: accountGUIDs },
            }),
        enabled: accountGUIDs.length > 0,
    });

export const useAccountYtdTaxMetrics = (accountGUID?: GUID<Account>, options?: { throwOnError?: boolean }) =>
    useQuery({
        ...options,
        queryKey: ytdTaxMetricsQueryKey(accountGUID),
        queryFn: async () => {
            const metrics = await taxMetricsApi.getYtdTaxMetrics({
                ytdTaxMetricsRequest: { accountGuids: [accountGUID!] },
            });
            return metrics.find((metric) => metric.accountGuid === accountGUID) ?? null;
        },
        enabled: !!accountGUID,
    });
